import { render, staticRenderFns } from "./invoice-email.button.vue?vue&type=template&id=3427528e&"
import script from "./invoice-email.button.vue?vue&type=script&lang=js&"
export * from "./invoice-email.button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports